export enum ActionType {
  'Link',
  'OpenWindow',
  'Method',
  'OpenModal',
  'RenderComponent',
}
